import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState, useRef} from "react";
import {Button} from "react-bootstrap";
import {useTranslation} from "react-i18next";


const TopBarActionsCustom = ({items, actions, params, filters, _TC}) => {
    const {t: _Tc} = useTranslation("choices");
    const [dataSelects, setDataSelects] = useState({
        state: "",
        device_group: "",
        asset_group: "",
        island: "",
        model: "",
        config: "",
    });
    const status = useRef(["s", "p", "e"]);
    const toInteger = [
        "group_device_id",
        "model_id",
    ];
    const onChange = (e) => {
        const {name, value} = e.target;
        if (value) {
            if (toInteger.includes(name)) {
                filters.current.chosen[name] = parseInt(value);
            } else {
                filters.current.chosen[name] = value;
            }
        } else {
            delete filters.current.chosen[name];
        }
        if (e.target.dataset.select) {
            let data = {...dataSelects};
            data[e.target.dataset.select] = value;
            setDataSelects(data);
        }
        filters.current.filter()
    };

    const onSearcher = (e) => {
        if (e.target.value) {
            filters.current.chosen.searcher = e.target.value;
        } else {
            delete filters.current.chosen["searcher"];
            filters.current.onChangeSearcher("");
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        filters.current.onChangeSearcher(filters.current.chosen.searcher);
    }

    return (
        <>
            <nav className="navbar navbar-expand w-100">
                <div className="d-flex m-2 ms-5 w-100">
                    <div className="navbar-brand me-5">{actions.title}</div>
                    <button
                        className="navbar-toggler "
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent "
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div id="navbarSupportedContent" className="w-100">
                        <ul className="navbar-nav ">
                            <li className="nav-item me-2">
                                <Button
                                    variant="link"
                                    type="button"
                                    onClick={actions.send.onClick}
                                    disabled={actions.send.disabled}>
                                    <FontAwesomeIcon icon="paper-plane"/>
                                </Button>
                            </li>
                            <li>
                                <small className="text-muted ms-3">
                                    {_TC("filter.search")}
                                </small>
                                <div className="d-flex" role="search">
                                    <form
                                        className="d-flex ms-auto"
                                        role="search"
                                        onSubmit={handleSubmit}>
                                        <input
                                            className="form-control border-end-0 rounded-end-0"
                                            type="search"
                                            name="searcher"
                                            placeholder={_TC("filter.search.placeholder")}
                                            aria-label={_TC("filter.search")}
                                            onInput={onSearcher}
                                        />
                                        <span
                                            className="input-group-text bg-white border-start-0 rounded-start-0"
                                            id="basic-addon1">
                                        <FontAwesomeIcon icon="fa-solid fa-magnifying-glass"/>
                                        </span>
                                    </form>
                                </div>
                            </li>
                            <li>
                                <div className="form-floating ms-3 mt-1">
                                    <select
                                        className="form-select"
                                        id="filter-format"
                                        name="format"
                                        aria-label={_TC("label.format")}
                                        data-select="format"
                                        value={dataSelects.format}
                                        onChange={onChange}>
                                        <option value="">
                                            {_TC("filter.select.option")}
                                        </option>
                                        <option value="b">{_TC("basic")}</option>
                                        <option value="a">{_TC("advanced")}</option>
                                    </select>
                                    <label htmlFor="filter-format">
                                        {_TC("label.format")}
                                    </label>
                                </div>
                            </li>
                            <li>
                                <div className="form-floating ms-3 mt-1">
                                    <select
                                        className="form-select"
                                        id="filter-status"
                                        name="state"
                                        aria-label={_TC("filter.select.status")}
                                        data-select="state"
                                        value={dataSelects.state}
                                        onChange={onChange}>
                                        <option value="">
                                            {_TC("filter.select.option")}
                                        </option>
                                        {status.current.map((stuff, idx) => (
                                            <option key={idx} value={stuff}>
                                                {_Tc("shippingState." + stuff)}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="filter-status">
                                        {_TC("filter.label.status")}
                                    </label>
                                </div>
                            </li>
                            <li>
                                <div className="form-floating ms-3 mt-1">
                                    <select
                                        className="form-select"
                                        id="filter-device_group"
                                        name="group_device_id"
                                        aria-label={_TC("filter.select.device_group")}
                                        data-select="device_group"
                                        value={dataSelects.device_group}
                                        onChange={onChange}>
                                        <option value="">
                                            {_TC("filter.select.option")}
                                        </option>
                                        {params.groups.map((stuff, idx) => (
                                            <option key={idx} value={stuff.id}>
                                                {stuff.name}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="filter-device_group">
                                        {_TC("filter.label.device_group")}
                                    </label>
                                </div>
                            </li>

                            <li>
                                <div className="form-floating ms-3 mt-1">
                                    <select
                                        className="form-select"
                                        id="filter-models"
                                        name="model_id"
                                        aria-label={_TC("filter.select.model")}
                                        data-select="model"
                                        value={dataSelects.model}
                                        onChange={onChange}>
                                        <option value="">
                                            {_TC("filter.select.option")}
                                        </option>
                                        {params.models.map((stuff, idx) => (
                                            <option key={idx} value={stuff.id}>
                                                {stuff.name}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="filter-modes">
                                        {_TC("filter.label.model")}
                                    </label>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default TopBarActionsCustom;
